module.exports = __webpack_public_path__ + "img/未标题-13.f2ef7365.png";